/**
 * MeetingCommentService
 * Service for MeetingComment entity operations
 * Route: api/meetingcomments
 * Controller: MeetingCommentsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingCommentService
 * Handles meeting comment CRUD operations
 * Maps to /api/meetingcomments endpoint
 */
export class MeetingCommentService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingCommentService.DEFAULT_SERVICE_PATH,
            basePath: MeetingCommentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingCommentService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingCommentService.BASE_PATH = 'api/meetingcomments';
//# sourceMappingURL=MeetingCommentService.js.map